module.exports = __webpack_public_path__ + "static/media/201IT245.737882d6.jpg";